import { countUpValue } from '@captaincause/lib/amount'
import { useNextLocale } from '@captaincause/lib/useNextLocale'
import { Icon } from '@captaincause/ui/Icon'
import type { Campaign, DirectCampaign } from '@captaincause/types'

interface CampaignProgressProps {
  campaign: Campaign
}

const FLIP_AMOUNT_THRESHOLD = 75

export function CampaignProgress({ campaign }: CampaignProgressProps) {
  const locale = useNextLocale()

  if (!campaign.progress_bar) {
    return null
  }

  const percent = Math.min(
    100,
    (100 * campaign.progress_bar.participation_count) /
      campaign.progress_bar.participation_objective,
  )

  if (percent < 1) {
    return null
  }

  return (
    <section
      className="relative hidden px-6 pb-6 pt-10 md:block lg:px-10 xl:px-20"
      style={{
        backgroundColor: campaign.primary_text_color,
        color: campaign.primary_color,
      }}
    >
      <div className="mx-auto max-w-screen-2xl">
        <div className="relative h-[120px] w-full">
          <div
            className="absolute bottom-0 left-0  h-[100px] w-px opacity-50"
            style={{
              left: `${percent}%`,
              background: `repeating-linear-gradient(to bottom, ${campaign.primary_color} 0px, ${campaign.primary_color} 4px, transparent 4px, transparent 10px)`,
            }}
          >
            <Icon
              icon="heart-fill"
              style={{ fill: campaign.primary_color }}
              size="medium"
              className="absolute -left-[9px] -top-[24px] opacity-50"
            />
          </div>
          <div
            className="absolute bottom-5"
            style={{
              transform:
                percent >= FLIP_AMOUNT_THRESHOLD
                  ? 'translateX(-100%)'
                  : undefined,
              left: `calc(${percent}% ${
                percent >= FLIP_AMOUNT_THRESHOLD ? '-' : '+'
              } 22px)`,
              color: campaign.primary_color,
            }}
          >
            <div className="whitespace-nowrap text-5xl font-bold -tracking-[1.92px] lg:text-6xl">
              {countUpValue({
                value: campaign.progress_bar.participation_count,
                locale,
              })}
            </div>
            <span style={{ color: campaign.primary_color }} className="text-lg">
              participants déjà !
            </span>
          </div>
        </div>
        <div
          className="relative my-2 h-3 w-full overflow-hidden rounded-full"
          style={{ backgroundColor: `${campaign.primary_color}55` }}
        >
          <div
            className="absolute left-0 top-0 h-full w-full opacity-100"
            style={{
              transform: `translateX(-${100 - percent}%)`,
              backgroundColor: campaign.primary_color,
            }}
          />
        </div>
        <div
          className="w-full text-right font-medium opacity-50"
          style={{ color: campaign.primary_color }}
        >
          Objectif : {campaign.progress_bar.participation_objective}
        </div>
      </div>
    </section>
  )
}
